function getLastIdUsingPop(gid) {
  return gid.split("/").pop();
}

// Product/variant titles and option values are merchant-editable free text from the
// Storefront API response, not this theme's own escaped Liquid output — must be escaped
// before going into innerHTML.
function escHtml(str) {
  return String(str ?? '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
}

document.addEventListener("DOMContentLoaded", function() {
const root = document.getElementById('serumQuizWidget');
const button = root.querySelector('.procced__btn');
const popup = root.querySelector('.quiz-popup-container');
const closeBtn = root.querySelector('#popupCloseBtn-serum');
const nextBtn = root.querySelector('#nextBtn-serum');
const prevBtn = root.querySelector('#prevBtn-serum');
const quizContentDiv = root.querySelector('.quiz-popup-content-div');
const quizHeader = root.querySelector('.quiz-popup-header');
const quizHeaderHide = root.querySelector('.quiz-popup-header-result');
const questionss = root.querySelector('.quiz-question');
 const instructions = root.querySelector('.quiz-instruction');
 const optionss = root.querySelector('.quiz-option-container');
let selectedValues = [];
let selectedTags = [];
let currentStep = 1;
popup.classList.remove('active');

const questions = [
  {
    question: "Which Age Group describes you best?",
    options: [
      { value: "18-29 Years", tag: "serum_age", img: "" },
      { value: "30-39 Years", tag: "serum_age", img: "" },
      { value: "40-49 Years", tag: "serum_age", img: "" },
      { value: "50+ Years", tag: "serum_age", img: "" }
    ]
  },
  {
    question: "Tell us about your skin type",
    options: [
      { value: "Oily", tag: "serum_oily", img: "https://cdn.shopify.com/s/files/1/0361/8553/8692/files/Group_2708_6bd69b4f-a286-477e-a0c6-b487b3b34145.png?v=1738391766" },
      { value: "Dry", tag: "serum_dry", img: "https://cdn.shopify.com/s/files/1/0361/8553/8692/files/Group_2712_e9605a38-62c3-4581-bff9-90efeca69494.png?v=1738391982" },
      { value: "Sensitive", tag: "serum_sensitive", img: "https://cdn.shopify.com/s/files/1/0361/8553/8692/files/Group_2713_10a54df0-c792-4a7a-8242-2f0de23ee8d5.png?v=1738392034" },
      { value: "Combination (Oily T-Zone, Rest Feels Dry)", tag: "serum_combination", img: "https://cdn.shopify.com/s/files/1/0361/8553/8692/files/Group_2710_bf127372-d6d5-4f1b-9e09-9aeeadc84204.png?v=1738391910" },
      { value: "Normal", tag: "serum_normal", img: "https://cdn.shopify.com/s/files/1/0361/8553/8692/files/Layer_1.svg?v=1738734863" }
    ]
  },
  {
    question: "What's your Primary Skin Concern?",
    options: [
      { value: "Blemishes & Acne Marks", tag: "serum_acnemark", img: "https://cdn.shopify.com/s/files/1/0361/8553/8692/files/Group_2738_1e488da2-a454-4745-a344-db8010c723eb.png?v=1739523719" },
      { value: "Dullness & Pigmentation", tag: "serum_dullness", img: "https://cdn.shopify.com/s/files/1/0361/8553/8692/files/Group_2739_b795257d-03d0-41ac-be27-38988abc2806.png?v=1739523772" },
      { value: "Wrinkles & Fine Lines", tag: "serum_wrinkle", img: "https://cdn.shopify.com/s/files/1/0361/8553/8692/files/Group_2740_2512039d-ced3-496e-a9f3-e7f4299b805f.png?v=1739523823"},
      { value: "Uneven Skin Texture", tag: "serum_textured", img: "https://cdn.shopify.com/s/files/1/0361/8553/8692/files/Group_2741_f44d33bf-aed7-4acc-8000-d9bf0b584bd9.png?v=1739523878"},
      { value: "Dry & Damaged Skin", tag: "serum_damaged", img: "https://cdn.shopify.com/s/files/1/0361/8553/8692/files/Group_2742_7a338b8f-3177-4b95-a3c3-4bb1cdc6f558.png?v=1739523928" },
      //{ value: "Dullness & Uneven Skin Tone", tag: "Serum_dullness", img: "https://cdn.shopify.com/s/files/1/0361/8553/8692/files/Group_2743_73ef3266-c754-42ab-a6a3-c9f6f2f32a9f.png?v=1739523982"},
      { value: "Active Acne & Redness", tag: "serum_activeacne", img: "https://cdn.shopify.com/s/files/1/0361/8553/8692/files/Group_2744_646aa4c3-9585-4ca4-8872-62b747576601.png?v=1739524031"}
    ]
  }
];

 closeBtn.addEventListener('click', function() {
  popup.classList.remove('active');
  document.body.classList.remove('popup-active');

  // Enable scroll on body
  document.body.style.overflow = '';

  // Remove overlay
  const overlay = document.querySelector('.popup-overlay');
  if (overlay) overlay.remove();

  // Reset quiz to initial state
  currentStep = 1;
  selectedValues = [];
  selectedTags = [];

  // Reset progress bar and image
  const progressBar = root.querySelector('.quiz-progress-bar');
  const progressImg = root.querySelector('.serum-quiz-progress-bar-container img');
  if (progressBar) progressBar.style.width = '0%';
  if (progressImg) progressImg.style.left = '-5%';

  // Restore UI elements
  quizHeaderHide.style.display = '';
  nextBtn.style.display = 'block';
  root.querySelector('.result-container').style.display = 'none';
  prevBtn.style.display = 'none';
  instructions.style.display = 'block';
  questionss.style.display = 'block';
  optionss.style.display = 'flex';
  nextBtn.disabled = true;
  loadQuestion();
});

  function openQuizPopup() {
    popup.classList.add('active');
    document.body.classList.add('popup-active');
    closeBtn.setAttribute("current-step", "step-1");

    // Disable scroll on body
    document.body.style.overflow = 'hidden';

    // Disable background interaction (optional layer)
    const overlay = document.createElement('div');
    overlay.classList.add('popup-overlay');
    document.body.appendChild(overlay);

    loadQuestion();
  }

  // Card's own PROCEED button (shown on individual collection pages).
  button.addEventListener('click', openQuizPopup);

  // Shop-All panel: open when Proceed is clicked AND this popup's unique class
  // was injected onto .collection-section-quiz.
  document.addEventListener('click', function(e) {
    if (!e.target.closest('.csq-proceed')) return;
    const panel = document.querySelector('.collection-section-quiz');
    if (panel && panel.classList.contains('quiz-popup-serum')) openQuizPopup();
  });

  nextBtn.disabled = true;

  nextBtn.addEventListener('click', function() {
    if (currentStep > 1) {
        prevBtn.style.display = 'block'; // Ensure previous button is visible
    }

    if (selectedValues[currentStep - 1]) {  // Ensure user selects an option
        if (currentStep < questions.length) {
            currentStep++;
            loadQuestion();
            prevBtn.classList.add('active');
        } else {
            showResults();
            prevBtn.classList.remove('active');
        }
    }
});

prevBtn.addEventListener('click', function() {

    if (currentStep > 1) {
        currentStep--;
        loadQuestion();

        if (currentStep === 1) {
            prevBtn.classList.remove('active'); // Hide previous button at first step
        }
    }
});


  function loadQuestion() {
    const currentQuestion = questions[currentStep - 1];
    if(root.querySelector('.result-container')) {
      root.querySelector('.result-container').style.display = 'none';
    }
    //console.log("currentQuestion",currentQuestion);
    quizContentDiv.querySelector('.quiz-question').textContent = currentQuestion.question;
    quizContentDiv.querySelector('.quiz-instruction').textContent = "Select only 1...";

    const quizOptionsContainer = root.querySelector('#quizOptions-serum');
    quizOptionsContainer.innerHTML = ''; // Clear previous options

    currentQuestion.options.forEach(option => {
      const optionDiv = document.createElement('div');
      optionDiv.classList.add('quiz-option');
      optionDiv.setAttribute('data-value', option.value);
      optionDiv.setAttribute('data-tag', option.tag); // Set dynamic tag to option

      if (option.img) {
        const optionImg = document.createElement('img');
        optionImg.src = option.img;
        optionImg.alt = option.value + " Image";
        optionDiv.appendChild(optionImg);
      }

      const optionText = document.createElement('span');
      optionText.textContent = option.value;
      optionDiv.appendChild(optionText);

      // Check if this option was previously selected and add 'selected' class
      if (selectedValues[currentStep - 1] === option.value) {
        optionDiv.classList.add('selected');
      }

      quizOptionsContainer.appendChild(optionDiv);
    });

    setOptionListeners();

    root.querySelectorAll('.step-number').forEach((step, index) => {
      step.classList.remove('active');
      const img = root.querySelector('.serum-quiz-progress-bar-container img');
      const progressBar = root.querySelector('.quiz-progress-bar');

if (index < currentStep) {
    step.classList.add('active');

    let leftPercentage = -5;
    let widthPercentage = 0;

    if (index === 1) {
        leftPercentage = 47;
        widthPercentage = 50;
    } else if (index === 2) {
        leftPercentage = 97;
        widthPercentage = 100;
    }

    // **Bar width should change instantly**
    progressBar.style.width = `${widthPercentage}%`;

    // **Image should move smoothly**
    let duration = 275; // Adjust this for image animation speed
    let frameRate = 60; // Smoothness
    let totalFrames = (duration / 1000) * frameRate;
    let currentFrame = 0;

    let startLeft = parseFloat(img.style.left) || -5;
    let stepLeft = (leftPercentage - startLeft) / totalFrames;

    function animateImage() {
        if (currentFrame < totalFrames) {
            startLeft += stepLeft;
            img.style.left = `${startLeft}%`;

            currentFrame++;
            requestAnimationFrame(animateImage);
        } else {
            img.style.left = `${leftPercentage}%`;
        }
    }

    requestAnimationFrame(animateImage);
}
    });
  }

function showResults() {
    //console.log("Selected Tags:", selectedTags); // Log selected tags

    quizHeaderHide.style.display = 'none';
    closeBtn.style.display = 'block';
    closeBtn.removeAttribute("current-step"); // (optional: clean up)
    closeBtn.setAttribute("current-step", "result-page");
    instructions.style.display = 'none';
    questionss.style.display = 'none';
    optionss.style.display = 'none';

    const mainDiv = root.querySelector('.result-container');
    mainDiv.innerHTML = '';
    mainDiv.style.display = 'block';
    const resultHeader = document.createElement('h3');
    resultHeader.innerHTML = 'Your Perfect <span>Serum</span> Match Is Here';
    mainDiv.appendChild(resultHeader);

    nextBtn.style.display = 'none';
    prevBtn.style.display = 'none';

    const shopifyDomain = 'https://dot-key.myshopify.com/api/2023-10/graphql.json';
    const accessToken = '6af1924966e71091c6d3b9e82a3076dd';

    const tagFilter = selectedTags.map(tag => `tag:'${tag}'`).join(' AND ');
    //console.log("Constructed Tag Filter:", tagFilter);

    const query = `
        query ProductByCollection {
        collection(id: "gid://shopify/Collection/177241063556") {
            products(first: 250, sortKey: BEST_SELLING) {
                edges {
                    node {
                        id
                        title
                        handle
                        variants(first: 6) {
                            edges {
                                node {
                                    id
                                    title
                                    priceV2 {
                                        amount
                                    }
                                    compareAtPriceV2 {
                                        amount
                                    }
                                    sku
                                    selectedOptions {
                                        name
                                        value
                                    }
                                }
                            }
                        }
                        images(first: 1) {
                            nodes {
                                url
                            }
                        }
                        tags
                    }
                }
            }
        }
    }
    `;


    //console.log("GraphQL Query:", query);

    fetch(shopifyDomain, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'X-Shopify-Storefront-Access-Token': accessToken,
        },
        body: JSON.stringify({ query })
    })
    .then(response => response.json())
    .then(data => {
    //console.log("GraphQL Response:", data); // Log the complete response

        if (data.data.collection && data.data.collection.products && data.data.collection.products.edges.length > 0) {
            const products = data.data.collection.products.edges;
            //console.log("Found Products:", products); // Log all found products

            // Find products with matching tags
            const matchingProduct = products.find(product => {
                const productTags = product.node.tags;
                //console.log("Product Tags for", product.node.title + ":", productTags); // Log tags for each product
                const matches = selectedTags.every(tag => productTags.includes(tag));
                //console.log("Matches all selected tags?", matches);
                return matches;
            });

            //console.log("Matching Product:", matchingProduct); // Log the final matching product

            if (matchingProduct) {
                let product = matchingProduct.node;
                let activeVariant = product.variants.edges[0].node; // Default first variant
                let activeIsColorVariant = activeVariant.selectedOptions.some(option => option.name.toLowerCase() === "color");
                let comparePrice = activeVariant.compareAtPriceV2 ? parseFloat(activeVariant.compareAtPriceV2.amount) : null;
                let currentPrice = parseFloat(activeVariant.priceV2.amount);
                let activeColorValue = "";
                  if (activeIsColorVariant) {
                      const colorOption = activeVariant.selectedOptions.find(option => option.name.toLowerCase() === "color");
                      if (colorOption) {
                          activeColorValue = colorOption.value;
                      }
                  }
                let discountPercentage = (comparePrice && comparePrice !== currentPrice) ? Math.round(((comparePrice - currentPrice) / comparePrice) * 100) : null;
                let productHtml = `
                    <div class="product-item-wrapper">
                        <div class="product-item-cstm-results">
                            <a class="product-link" href='/products/${escHtml(product.handle)}'>
                              <img src="${escHtml(product.images.nodes[0].url)}" alt="${escHtml(product.title)}" />
                              <h4>${escHtml(product.title)}</h4>
                            </a>
                            <div class="variants-container">
                      <div class="max-parent-variant mt-5 mb-3 md:mb-0 md:mt-0 rtl:text-right">
                             <span class="swatch-title-card" style="color: #f62f48;">
                                 ${escHtml(activeColorValue)}
                              </span>
                              <div>
                `;

            product.variants.edges.forEach((variant, index) => {
                const isColorVariant = variant.node.selectedOptions.some(option => option.name.toLowerCase() === "color");
                let variantHtml = '';

                if (isColorVariant) {
                    // Extracting values needed for the button
                    const colorValue = variant.node.selectedOptions.find(option => option.name.toLowerCase() === "color").value;
                    const variantId = variant.node.id;
                    const variantImage = variant.node.image ? variant.node.image.src : '';
                    const variantPrice = variant.node.priceV2 ? variant.node.priceV2.amount : '';

                    // Using the provided button structure for color variants
                    variantHtml = `
                        <button
                            class="variant-button-${product.id} quiz variant-btn color_buttons ${escHtml(colorValue.replace(/\s+/g, '_').toLowerCase())} ${index === 0 ? 'v_active' : ''}"
                            data-option-name="Color"
                            data-option-value="${escHtml(colorValue)}"
                            data-variant-id="${getLastIdUsingPop(variantId)}"
                            data-image="${escHtml(variantImage)}"
                            data-variant-price="${variantPrice}">
                       </button>
                    `;
                } else {
                    variantHtml = `
                        <div class="variant-item-result ${index === 0 ? 'active' : ''}"
                            data-variant-id="${variant.node.id}">
                            <span>${escHtml(variant.node.title)}</span>
                        </div>
                    `;
                }

                productHtml += variantHtml;
            });


                productHtml += `
                                </div>
                              </div>
                            </div>
                            <div class="price-container">
                                <span class="price-display">₹${currentPrice}</span>
                                ${comparePrice && comparePrice !== currentPrice ?
                                    `<span class="compare-price">₹${comparePrice}</span>
                                    <span class="discount-percentage">(${discountPercentage}% OFF)</span>`
                                    : ''}
                            </div>
                            <product-form class="dev_atc_form parent-of-button" data-product-id="${getLastIdUsingPop(product.id)}">
                                <form class="form" action="/cart/add" method="post" data-product-form data-type="add-to-cart-form">
                                    <input type="hidden" class="product-variant-id" name="id" value="${getLastIdUsingPop(activeVariant.id)}">
                                    <input type="hidden" class="dev_getqty" name="quantity" value="1">
                                    <input type="hidden" name="properties[is_app]" value="true">
                                    <button type="submit" class="quiz_add_to_cart btn-anim add-tocart-button button button--full-width button--secondary"
                                    data-product-id="${getLastIdUsingPop(activeVariant.id)}" data-product-title="${escHtml(product.title)}" data-product-price="${parseFloat(activeVariant.priceV2.amount).toFixed(0)}">
                                        <span class="x-atc-text" data-button-text>ADD TO CART</span>
                                        <div class="absolute inset-0 hidden items-center justify-center" data-button-loader>
                                            <span style="display:flex;justify-content:center;align-items:center;">
                                                <img width="20" height="20" src="https://cdn.shopify.com/s/files/1/0361/8553/8692/files/Dot-_-Key-Loading-Animation-White.gif?v=1724248882&width=20" alt="" aria-hidden="true">
                                            </span>
                                        </div>
                                    </button>
                                    <div data-form-error style="color:#d0021b;font-size:12px;margin-top:6px;" hidden></div>
                                </form>
                            </product-form>
                        </div>
                    </div>
                `;

                const productContainer = document.createElement('div');
                productContainer.innerHTML = productHtml;
                mainDiv.appendChild(productContainer);

                const variantElements = productContainer.querySelectorAll('.variant-item-result');
                const hiddenInput = productContainer.querySelector('.product-variant-id');

                variantElements.forEach(variantElement => {
                    variantElement.addEventListener('click', () => {
                        const variantId = variantElement.getAttribute('data-variant-id');
                        const selectedVariant = product.variants.edges.find(v => v.node.id === variantId).node;

                        // Remove 'active' class from all variants and add to selected one
                        variantElements.forEach(v => v.classList.remove('active'));
                        variantElement.classList.add('active');

                        hiddenInput.value = getLastIdUsingPop(selectedVariant.id);

                        // Update price
                        let newComparePrice = selectedVariant.compareAtPriceV2 ? parseFloat(selectedVariant.compareAtPriceV2.amount) : null;
                        let newCurrentPrice = parseFloat(selectedVariant.priceV2.amount);
                        let newDiscountPercentage = (newComparePrice && newComparePrice !== newCurrentPrice) ? Math.round(((newComparePrice - newCurrentPrice) / newComparePrice) * 100) : null;

                        productContainer.querySelector('.price-display').textContent = `₹${newCurrentPrice}`;

                        const comparePriceDisplay = productContainer.querySelector('.compare-price');
                        const discountPercentageDisplay = productContainer.querySelector('.discount-percentage');

                        if (newComparePrice && newComparePrice !== newCurrentPrice) {
                            comparePriceDisplay.style.display = 'inline';
                            comparePriceDisplay.textContent = `₹${newComparePrice}`;
                            discountPercentageDisplay.style.display = 'inline';
                            discountPercentageDisplay.textContent = `(${newDiscountPercentage}% OFF)`;
                        } else {
                            comparePriceDisplay.style.display = 'none';
                            discountPercentageDisplay.style.display = 'none';
                        }
                    });
                });

                quizContentDiv.appendChild(mainDiv);
                setupVariantListeners(quizContentDiv);
            } else {
                //const noResultsMessage = document.createElement('p');
                //noResultsMessage.innerHTML = 'Sorry, no products found for your selection.';
                //mainDiv.appendChild(noResultsMessage);
              $(".result-container h3").html("Sorry, No Matching <span>Serum</span> Found For Your Match.");
            }
        } else {
            console.log("No products returned from GraphQL query");
        }
    })
    .catch(error => {
        //console.error('Error fetching product data:', error);
        const errorMessage = document.createElement('p');
        errorMessage.innerHTML = 'Sorry, there was an error finding your perfect match. Please try again.';
        mainDiv.appendChild(errorMessage);
    });
}

// Add logging to tag selection
function setOptionListeners() {
    const options = root.querySelectorAll('.quiz-option');
    options.forEach(option => {
        option.addEventListener('click', function() {
            options.forEach(opt => opt.classList.remove('selected'));
            this.classList.add('selected');

            const value = this.getAttribute('data-value');
            const tag = this.getAttribute('data-tag');
            //console.log("Selected Option Value:", value);
            //console.log("Selected Option Tag:", tag);

            selectedValues[currentStep - 1] = value;
            selectedTags[currentStep - 1] = tag;
            //console.log("Current Selected Values:", selectedValues);
            //console.log("Current Selected Tags:", selectedTags);

            //  Set current-select-value as all selected tags
            let tagList = selectedTags.filter(tag => tag).join(",");
            nextBtn.setAttribute("current-select-value", tagList);

            //  Set current-step as number of selected tags
            let stepCount = tagList ? tagList.split(",").length : 0;
            nextBtn.setAttribute("current-step", `step-${stepCount}`);
            closeBtn.setAttribute("current-step", `step-${stepCount}`);
          nextBtn.disabled = false;
        });
    });
}
});

  function setupVariantListeners(productContainer) {
      const variantButtons = productContainer.querySelectorAll('.quiz.variant-btn');
      variantButtons.forEach(button => {
          button.addEventListener('click', () => {
              const optionName = button.getAttribute("data-option-name");
              const optionValue = button.getAttribute("data-option-value");
              const variantId = button.getAttribute("data-variant-id");
              const variantImage = button.getAttribute("data-image");
              const variantPrice = button.getAttribute("data-variant-price");
              const priceWithoutDecimals = Math.round(parseFloat(variantPrice));
              handleOptionClick(button, optionName, optionValue, null, variantId, variantImage, priceWithoutDecimals);
          });
      });
  }


  function handleOptionClick(button, optionName, optionValue, productId, variantId, variantImage, variantPrice) {
    const buttons = document.querySelectorAll(`.quiz.variant-btn`);
    buttons.forEach(btn => btn.classList.remove('v_active'));

    // Add active class to the clicked button
    button.classList.add('v_active');

    const variantInputs = document.querySelectorAll(`.max-parent-variant-${productId} .product-variant-id`);
    variantInputs.forEach(input => input.value = variantId);

    // Update the variant ID input
    $(button).parents('.result-container')
        .find('.product-item-wrapper')
        .find('.dev_atc_form')
        .find('.form')
        .find('.product-variant-id')
        .val(variantId);

    // Update the swatch title for the specific card
    $(button).closest('.max-parent-variant').find('.swatch-title-card').text(optionValue);

    // Update the price for the specific variant
    const moneyPrint = $('.result-container').find('.price-display');
    moneyPrint.html(`₹${variantPrice}`);
  }
